/** Shared display formatting so dates and labels look the same on every page. */

const DATE: Intl.DateTimeFormatOptions = { day: "2-digit", month: "2-digit", year: "numeric" };

function parse(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }
  const d = new Date(value);
  return Number.isFinite(d.getTime()) ? d : null;
}

/** `23.01.2012`, or a dash. */
export function fmtDate(value: string | null | undefined): string {
  const d = parse(value);
  return d ? d.toLocaleDateString("de-DE", DATE) : "—";
}

/** `16.09.2026, 12:05`, or a dash. */
export function fmtDateTime(value: string | null | undefined): string {
  const d = parse(value);
  return d ? d.toLocaleString("de-DE", { dateStyle: "medium", timeStyle: "short" }) : "—";
}

// Matches the app's i18n `supportedLngs`.
const LANGUAGE_LABEL: Record<string, string> = { de: "Deutsch", en: "Englisch", fr: "Französisch" };

/** Display name of a preferred language; unset means the product default. */
export function languageLabel(code: string | null | undefined): string {
  if (!code) {
    return "Standard";
  }
  return LANGUAGE_LABEL[code] ?? code;
}
